import { render, staticRenderFns } from "./IndicadoresResumo.vue?vue&type=template&id=378493ec&scoped=true&"
import script from "./IndicadoresResumo.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResumo.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresResumo.vue?vue&type=style&index=0&id=378493ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378493ec",
  null
  
)

export default component.exports